<h1 mat-dialog-title>FBO Group Customer Pricing Report</h1>
<div class="subtitle">Select the customer(s) you'd like to generate a price sheet for.</div>

<div class="tags-dropdown">
<p-multiSelect class="tags-dropdown-filter"
               [options]="tags"
               [(ngModel)]="selectedTags"
               #multiInput
               display="chip"
               placeholder="No tags"
               optionLabel="label"
               autofocusFilter="true"
               [virtualScroll]="true"
               maxSelectedLabels="10"
               filterBy="label"
               [showToggleAll]="false"
               itemSize="50"
               resetFilterOnHide="true"
               (onChange)="onTagSelection($event)">
    <ng-template let-value pTemplate="selectedItems">
        <div class="p-multiselect-token" *ngFor="let selected of selectedTags">
            <span class="p-multiselect-token-label">
                {{ selected.label }}
            </span>
        </div>

        <div *ngIf="!selectedTags || selectedTags.length == 0">
            Select a Distribution List
        </div>
    </ng-template>
    <ng-template let-tags pTemplate="item">
        <div class="fbo-item">
            <div>{{ tags.label }}</div>
        </div>
    </ng-template>
</p-multiSelect>
</div>

<div mat-dialog-content class="dialogContent">
    <app-group-analytics-generate-dialog-grid [groupDistributionGridData]="dataSources" (customerSelectedClicked)="customerSelectedClicked($event)" (selectAllClicked)="selectAllClicked($event)" (manuallyCheckedChanged)="onManuallyCheckedChanged($event)"></app-group-analytics-generate-dialog-grid>
</div>
<div class="" mat-dialog-actions>
    <button (click)="onGenerate()"
            [disabled]="
            !selectedCustomers ||
            !selectedCustomers.length ||
            downloading ||
            emailing
        "
            color="accent"
            mat-raised-button>
        {{ !downloading ? "Generate and Download" : "" }}
        <mat-spinner *ngIf="downloading" diameter="20"></mat-spinner>
    </button>
    <button (click)="onEmail()"
            [disabled]="
            !selectedCustomers ||
            !selectedCustomers.length ||
            emailing ||
            emailing
        "
            color="green"
            mat-raised-button>
        {{ !emailing ? "Email Pricing" : "" }}
        <mat-spinner *ngIf="emailing" diameter="20"></mat-spinner>
    </button>
</div>
